import { PayloadAction } from '@reduxjs/toolkit';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { FN_SLICE__grid2d_recreate } from '../_methods/FN_SLICE__grid2d_recreate';
import { STATE__grid2d } from '../STATE__grid2d';

export const LOCAL__grid2d_delete = (payload: string[]): PayloadAction<string[]> => ({
  type: ENUM__redux_action.GRID2D_DELETE,
  payload,
});

export function INIT_LOCAL__grid2d_delete(state: STATE__grid2d, action: PayloadAction<string[]>) {
  if (action.payload.is_empty()) return;

  for (let id of action.payload) {
    state.grids2d_map.delete(id);
  }

  //refresh map to trigger re-render
  FN_SLICE__grid2d_recreate(state);
}
